const QIVORA_BASE = "https://custom-qivora.northcode.uk";

export type QivoraDate = { date: string; ship_date: string };

export type QivoraAvailableDatesResponse = {
  dates: QivoraDate[];
  cutoff_hours: number;
  timezone: string;
  allowed_delivery_days: number[];
  allowed_delivery_names: string[];
};

export async function fetchAvailableDates(
  shop: string,
  weeks = 4
): Promise<QivoraDate[]> {
  const res = await fetch(
    `${QIVORA_BASE}/public/available-dates?shop=${encodeURIComponent(shop)}&weeks=${weeks}`
  );
  if (!res.ok) throw new Error("Failed to fetch dates from Qivora");
  const data = await res.json();
  return (data.dates ?? []) as QivoraDate[];
}

export async function fetchAvailableDatesWithConfig(
  shop: string,
  weeks = 4
): Promise<QivoraAvailableDatesResponse> {
  const res = await fetch(
    `${QIVORA_BASE}/public/available-dates?shop=${encodeURIComponent(shop)}&weeks=${weeks}`
  );
  if (!res.ok) throw new Error("Failed to fetch dates from Qivora");
  const data = await res.json();
  return {
    dates: (data.dates ?? []) as QivoraDate[],
    cutoff_hours: data.cutoff_hours ?? 36,
    timezone: data.timezone ?? "Europe/London",
    allowed_delivery_days: (data.allowed_delivery_days ?? []) as number[],
    allowed_delivery_names: (data.allowed_delivery_names ?? []) as string[],
  };
}
